export enum AppNames {
	EMBEDDABLE_DIRECTORY = 'embeddableDirectory',
	STANDALONE_DIRECTORY = 'standaloneDirectory',
}

export function getAppName(): AppNames {
	// @ts-ignore
	return (window.__app_name__ as AppNames) || AppNames.EMBEDDABLE_DIRECTORY;
}
